import { jsPDF } from "jspdf";
import { autoTable } from "jspdf-autotable";
import LogoPdf from "/src/assets/images/logo.jpg";
import SelloAguaOrden from "/src/assets/images/original_mark.png";

import {
  decodeBase64Image,
  FORMAT_CURRENCY,
  FORMAT_DATETIME_DDMMYYYY,
  FORMAT_CURRENCY_AND_DOTS,
  TELEFONO_EMPRESA_SALMONES_DE_CHILE,
  DIRECCION_EMPRESA_SALMONES_DE_CHILE,
  GIRO_EMPRESA_SALMONES_DE_CHILE,
  USUARIO_CONFIRMA_GTE_GENERAL,
  FORMAT_CURRENCY_PESOS,
  FORMAT_CURRENCY_OTROS_NO_PESOS,
} from "../../utils/Constants";

const dataHead = {
  title: "Orden de Compra",
  company: "SALMONES DE CHILE Y PRODUCTORA S.A",
  rut: "RUT: 99.520.820-2",
  giro: GIRO_EMPRESA_SALMONES_DE_CHILE,
  direccion: DIRECCION_EMPRESA_SALMONES_DE_CHILE,
  telefonos: TELEFONO_EMPRESA_SALMONES_DE_CHILE,
  logo: LogoPdf,
};

// --- HELPER: Promise-based Image Loader ---
const loadImage = (src: string): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = src;
    img.onload = () => resolve(img);
    img.onerror = (err) => reject(err);
  });
};

interface CreatePdfTableProps {
  data: any;
  initData: any;
  ordenesApprovalStates: any[];
  solicitudesSignApprovalHistory: any[];
  dataProveedor: any;
  parametros: any;
}

// --- MAIN FUNCTION: Returns Promise<Blob> ---
async function CreatePdfTableOrdenesBlob({
  data,
  initData,
  ordenesApprovalStates,
  solicitudesSignApprovalHistory,
  dataProveedor,
  parametros,
}: CreatePdfTableProps): Promise<Blob> {
  try {
    const maxPageHeight = 279;
    const maxPageWidth = 216;
    const doc = new jsPDF({
      orientation: "p",
      unit: "mm",
      format: [maxPageHeight, maxPageWidth],
      compress: true, // This is crucial
    });
    const documentStyle = getComputedStyle(document.documentElement);

    // 1. LOAD LOGO (Blocking Wait)
    const logoImg = await loadImage(dataHead.logo);

    // 2. DRAW HEADER
    //HEAD IZQUIERDA
    doc.text(dataHead.company, 5, 10);
    doc.text(dataHead.rut, 5, 15);
    doc.setFontSize(5);
    doc.text(dataHead.giro, 5, 20, { maxWidth: 70 });

    doc.text(dataHead.direccion, 5, 30);
    doc.text(dataHead.telefonos, 5, 35);

    doc.setFontSize(6);

    let solicitante = "";
    let countMoveHeight = 0;
    data.detalle.map((val: any, i: number) => {
      if (solicitante.length !== val.solicitante.length) {
        solicitante = val.solicitante;
        countMoveHeight += 5;
        doc.text(
          "Solicitante " + (i + 1) + ": - " + val.solicitante,
          5,
          40 + countMoveHeight,
        );
        doc.text(
          "Centro Solicitante " + (i + 1) + ": " + val.cc_solicitante,
          5,
          45 + countMoveHeight,
        );
      }
    });

    doc.setFontSize(6);

    // Draw Logo
    doc.addImage(logoImg, "PNG", 95, 30, 20, 20, undefined, "FAST");
    doc.text(dataHead.title, 95, 50);

    doc.setFontSize(10);
    doc.text(
      "Tipo: " + data.subdoc_nombre + ", Estado: " + data.ocest_nombre,
      80,
      55,
    );
    doc.setTextColor("red");
    doc.setFontSize(10);
    doc.text("N°: " + data.oc_id, 95, 60);

    // Right Header
    doc.setTextColor("black");
    doc.text(
      "Fecha creación: " +
        (data.occ_impuesto_especifico
          ? FORMAT_DATETIME_DDMMYYYY(data.fecha_orden_combustible)
          : data.oc_dt_cre),
      160,
      10,
    );

    doc.setFontSize(6);
    doc.text("Estado Operacional: " + data.estope_nombre, 160, 15);
    doc.text("Documento Tributario: " + data.doctrib_nombre, 160, 20);

    //NUEVA SECCION PROVEEDOR SIN TABLA
    doc.setFontSize(10);

    doc.setTextColor("red");
    doc.text("Proveedor", 175, 30);
    doc.setTextColor("black");
    doc.setFontSize(8);
    doc.text("Razón social: " + dataProveedor.nombre + "" || "", 160, 35, {
      maxWidth: 50,
    });
    doc.text(
      "Rut: " + dataProveedor.identificador + "-" + dataProveedor.dv || "",
      160,
      44,
    );
    doc.text("Email: " + dataProveedor.email || "", 160, 47);
    doc.text("Teléfono: " + dataProveedor.telefono || "", 160, 50);
    doc.setFontSize(10);

    // 3. DRAW TABLES
    // PROVEEDOR TABLE
    /*autoTable(doc, {
      startY: 70,
      margin: { left: 18, right: 18 },
      styles: { halign: "center" },
      headStyles: {
        fillColor: documentStyle.getPropertyValue("--secondary-dark-color"),
        textColor: "white",
        halign: "center",
        fontSize: 8,
      },
      bodyStyles: { halign: "center", fontSize: 7 },
      tableLineWidth: 0.1,
      head: [
        [
          "Proveedor",
          "Dirección",
          "Rut",
          "Email",
          "Teléfono",
          "Contacto",
          "Teléfono Contacto",
        ],
      ],
      body: [
        [
          dataProveedor.nombre || "",
          dataProveedor.direccion +
            ", " +
            dataProveedor.ciudadNombre +
            ", " +
            dataProveedor.ciudadRegion || "",
          dataProveedor.identificador + "-" + dataProveedor.dv || "",
          dataProveedor.email || "",
          dataProveedor.telefono || "",
          dataProveedor.contactoNombre || "",
          dataProveedor.contactoTelefono || "",
        ],
      ],
      columnStyles: {
        0: { cellWidth: 30 },
        1: { cellWidth: 40 },
        2: { cellWidth: 20 },
        3: { cellWidth: 30 },
        4: { cellWidth: 20 },
        5: { cellWidth: 20 },
        6: { cellWidth: 20 },
      },
    });*/

    // DETAILS TABLE
    autoTable(doc, {
      startY: 70,
      styles: { halign: "center" },
      headStyles: {
        fillColor: documentStyle.getPropertyValue("--primary-app-color"),
        textColor: "white",
        halign: "center",
        fontSize: 8,
      },
      bodyStyles: { halign: "left", fontSize: 6 },
      tableLineWidth: 0.1,
      head: [
        [
          "Id",
          "Centro Costo",
          "Proveedor",
          "Item",
          "U.M",
          "Cantidad",
          "Precio Unitario",
          "Total",
          "Mes Gasto",
        ],
      ],
      body: data.detalle
        .filter(
          (row: { ocest_id: number }) =>
            row.ocest_id !== 1 && row.ocest_id !== 2 && row.ocest_id !== 4,
        )
        .map((val: any, i: number) => [
          i + 1,
          val.sdetcc_id + "-" + val.sdetcc_nombre,
          data.prov_id + "-" + data.prov_nombre,
          val.item_id + "-" + val.item_nombre,
          val.um_codigo,
          val.ocdet_cantidad,
          data.tipmon_id === 1
            ? FORMAT_CURRENCY_PESOS(parseFloat(val.ocdet_precio_unitario))
            : FORMAT_CURRENCY_OTROS_NO_PESOS(
                parseFloat(val.ocdet_precio_unitario).toFixed(2),
              ),
          data.tipmon_id === 1
            ? FORMAT_CURRENCY_PESOS(parseFloat(val.ocdet_precio_total))
            : FORMAT_CURRENCY_OTROS_NO_PESOS(
                parseFloat(val.ocdet_precio_total).toFixed(2),
              ),
          data.meses_nombre,
        ]),
      columnStyles: {
        0: { cellWidth: 8 },
        1: { cellWidth: 30 },
        2: { cellWidth: 30 },
        3: { cellWidth: 30 },
        4: { cellWidth: 10 },
        5: { cellWidth: 20 },
        6: { cellWidth: 20 },
        7: { cellWidth: 25 },
        8: { cellWidth: 15 },
      },
    });

    // @ts-ignore
    let finalYTableOne = doc.canvas.pdf.lastAutoTable.finalY;

    if (finalYTableOne + 50 > maxPageHeight) {
      doc.addPage();
    }

    // OBSERVACIONES TABLE
    autoTable(doc, {
      startY: finalYTableOne + 10,
      styles: { halign: "center" },
      headStyles: {
        fillColor: documentStyle.getPropertyValue("--primary-app-color"),
        textColor: "white",
        halign: "left",
        fontSize: 8,
      },
      bodyStyles: { halign: "left", fontSize: 7 },
      tableLineWidth: 0.1,
      head: [["Id", "N° Solicitud detalle", "Observaciones"]],
      body: data.detalle
        .filter(
          (row: { ocest_id: number }) =>
            row.ocest_id !== 1 && row.ocest_id !== 2 && row.ocest_id !== 4,
        )
        .map((val: any, i: number) => [
          i + 1,
          val.ocdet_id_solicitud_orden_compra_detalle,
          val.ocdet_observaciones,
        ]),
      columnStyles: {
        0: { cellWidth: 15 },
        1: { cellWidth: 30 },
        2: { cellWidth: 143 },
      },
    });

    // @ts-ignore
    let finalYTableTwo = doc.canvas.pdf.lastAutoTable.finalY;

    if (finalYTableTwo + 40 > maxPageHeight) {
      doc.addPage();
      finalYTableTwo = 10;
    }

    //CONDICION DE PAGO REUBICADO
    doc.setFontSize(6);
    doc.text(
      "Condiciones de pago: " + data.condpago_nombre,
      15,
      finalYTableTwo + 15,
    );

    doc.text("Tipo Moneda: " + data.tipmon_nombre, 15, finalYTableTwo + 20);

    doc.setFontSize(8);

    // TOTALS CALCULATION
    let totalNeto = 0;
    let iva = parametros.find(
      (param: { codigo: string }) => param.codigo === "IVA",
    )?.valor;
    let ivaLabel = 0;
    let boletaImpuesto = parametros.find(
      (param: { codigo: string }) => param.codigo === "BOLETA",
    )?.valor;

    let boletaImpuestoLabel = parametros.find(
      (param: { codigo: string }) => param.codigo === "BOLETA_L",
    )?.valor;

    let montoFirmaGte = parametros.find(
      (param: { codigo: string }) => param.codigo === "OC_FIR_GTE",
    )?.valor;

    let conversionMoneda = 1;
    switch (data.tipmon_id) {
      case 1:
        conversionMoneda = 1;
        break;
      case 2:
        let dolarCotizacion = parametros.find(
          (param: { codigo: string }) => param.codigo === "DOLAR_COT",
        )?.valor;
        conversionMoneda = parseFloat(dolarCotizacion);
        break;
      case 3:
        let euroCotizacion = parametros.find(
          (param: { codigo: string }) => param.codigo === "EURO_COT",
        )?.valor;
        conversionMoneda = parseFloat(euroCotizacion);
        break;
      case 40:
        let ufCotizacion = parametros.find(
          (param: { codigo: string }) => param.codigo === "UF_COT",
        )?.valor;
        conversionMoneda = parseFloat(ufCotizacion);
        break;
      default:
        conversionMoneda = 1;
    }

    /*data.detalle.map((val: any, i: number) => {
        if (
          ((val.ocest_id === 8 || val.oces_id === 6) &&
            val.ocdet_precio_total * conversionMoneda < montoFirmaGte) ||
          (val.ocest_id === 10 &&
            val.ocdet_precio_total * conversionMoneda > montoFirmaGte)
        ) {
          totalNeto += val.ocdet_precio_total || 0;
        }
      });*/

    data.detalle.map((val: any, i: number) => {
      if (val.ocest_id == 1 || val.ocest_id > 5) {
        totalNeto += val.ocdet_precio_total || 0;
      }
    });

    let totalAfecto = 0;
    let totalAfectoNoFormat = 0;
    let totalAfectoCombustible = 0;
    let totalAfectoNoFormatConvertedForVal = 0;

    if (data.doctrib_id == 1) {
      totalAfecto = totalNeto * iva;
      totalAfectoNoFormat = totalAfecto;
      ivaLabel = (iva - 1) * 100;
      ivaLabel = parseFloat(ivaLabel.toFixed(0));
      totalAfectoCombustible =
        totalAfecto + Number(data.occ_impuesto_especifico);
    } else if (data.doctrib_id == 3) {
      totalAfecto = totalNeto * boletaImpuesto;
      totalAfectoNoFormat = totalAfecto;
      boletaImpuestoLabel = Number(
        parseFloat(boletaImpuestoLabel),
      ).toLocaleString("es-ES", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } else {
      totalAfectoNoFormat = totalNeto;
      //totalAfecto = FORMAT_CURRENCY_AND_DOTS(totalNeto);
      totalAfectoCombustible = FORMAT_CURRENCY_PESOS(
        totalAfectoNoFormat + Number(data.occ_impuesto_especifico),
      );

      totalAfecto =
        data.tipmon_id === 1
          ? FORMAT_CURRENCY_PESOS(totalNeto)
          : FORMAT_CURRENCY_OTROS_NO_PESOS(totalNeto);
    }
    //totalAfecto = FORMAT_CURRENCY_AND_DOTS(totalAfecto);
    totalAfecto =
      data.tipmon_id === 1
        ? FORMAT_CURRENCY_PESOS(totalAfecto)
        : FORMAT_CURRENCY_OTROS_NO_PESOS(totalAfecto);
    totalAfectoNoFormatConvertedForVal = totalAfectoNoFormat * conversionMoneda;

    totalAfectoCombustible = FORMAT_CURRENCY_PESOS(
      totalAfectoNoFormat + Number(data.occ_impuesto_especifico),
    );

    const columnAuxStyles = {
      0: { cellWidth: 30 },
      1: { cellWidth: 15 },
      2: { cellWidth: 30 },
    };

    const columnAuxStylesCombustible = {
      0: { cellWidth: 20 },
      1: { cellWidth: 15 },
      2: { cellWidth: 20 },
      3: { cellWidth: 20 },
    };

    const hasCombustible = Boolean(data.occ_impuesto_especifico);

    // Calculate cell values
    const totalNetoFormatted =
      data.tipmon_id === 1
        ? FORMAT_CURRENCY_PESOS(totalNeto)
        : FORMAT_CURRENCY_OTROS_NO_PESOS(totalNeto) || "";

    const ivaFormatted =
      data.doctrib_id == 1
        ? ivaLabel + "%"
        : data.doctrib_id === 3
          ? boletaImpuestoLabel + "%"
          : "0%";

    const bodyRow = hasCombustible
      ? [
          totalNetoFormatted,
          ivaFormatted,
          FORMAT_CURRENCY_PESOS(data.occ_impuesto_especifico),
          totalAfectoCombustible,
        ]
      : [
          totalNetoFormatted,
          ivaFormatted,
          totalAfecto, // Now aligns directly under "Total"
        ];

    autoTable(doc, {
      startY: finalYTableTwo + 10,
      margin: { left: 127 },
      styles: { halign: "right" },
      headStyles: {
        fillColor: documentStyle.getPropertyValue("--primary-app-color"),
        textColor: "white",
        halign: "center",
        fontSize: 8,
      },
      bodyStyles: { halign: "center" },
      alternateRowStyles: {
        fillColor: "white",
        textColor: "black",
        fontSize: 7,
      },
      tableLineWidth: 0.1,
      head: hasCombustible
        ? [["Total Neto", "IVA/IMP", "I.E", "Total"]]
        : [["Total Neto", "IVA/IMP", "Total"]],
      body: [bodyRow],
      columnStyles: hasCombustible
        ? columnAuxStylesCombustible
        : columnAuxStyles,
    });

    // @ts-ignore
    let finalYTableThree = doc.canvas.pdf.lastAutoTable.finalY;

    if (finalYTableThree + 100 > maxPageHeight) {
      doc.addPage();
      finalYTableThree = 10;
    }

    // FOOTER CUADROS
    doc.setFontSize(7);
    doc.rect(4, finalYTableThree + 5, 85, 20);
    doc.text(
      "MENCIONAR O/C EN FACTURA VALIDEZ 180 DIAS DE EMISION",
      8,
      finalYTableThree + 10,
    );

    let messageFooterValidez =
      "Salmones de Chile y Productora S.A., se reserva el derecho de rechazar parcial o totalmente este pedido si no reune las condiciones pactadas, ya sea calidad, diseño, cantidad o el no cumplimiento en las fechas de entrega. No se pagará ninguna factura que no venga en duplicado, adjuntanto copia de orden de compra y guia de entrega firmada conforme.";
    doc.setFontSize(5);

    var splitMessageFooterValidez = doc.splitTextToSize(
      messageFooterValidez,
      80,
    );
    doc.text(splitMessageFooterValidez, 6, finalYTableThree + 14);

    doc.rect(95, finalYTableThree + 5, 115, 20);
    let messageFooter =
      "El proveedor confirma que al aceptar esta orden de compra, declara no estar involucrado, ni haberlo estado, en delitos que pongan en riesgo la responsabilidad empresarial del emisor de este documento de acuerdo a la ley 20393, y asi mismo, se obliga a denunciar cualquier acto, transaccióon u operación sospechosa que advirtiera en el ejercicio de sus actividades y que pongan en riesgo el cumplimiento de la normativa señalada al respecto. Dichas denuncias deberán ser canalizadas a través del correo denuncias@salmonesdechile.com, en la cual el área receptora de esta información, procederá a tomar las medidas correspondientes según sea el caso.";
    var splitMessageFooter = doc.splitTextToSize(messageFooter, 106);
    doc.text(splitMessageFooter, 98, finalYTableThree + 10);

    //CUADRO DE FACTORING
    doc.rect(4, finalYTableThree + 28, 206, 10);
    let messageFooterFactoring =
      "CESION DE DOCUMENTOS A FACTORING: Toda factura emitida a Salmones de Chile y Productora S.A; R.U.T: 99.520.820-2 debe contar con el respectivo visto bueno de quien solicita el servicio la cual debe ser enviada con firma, en caso de tratarse de facturas por productos, éstas deben contar con timbre de recepción de bodega. Sólo se autorizarán documentos que no posean más de 15 días corridos desde su emisión, al momento de realizar la operación, enviar toda la documentación a finanzassdc@salmonesdechile.com. IMPORTANTE: Todo documento factorizado mantiene condición de pago a 90 días desde la fecha de la CESION.";
    var splitMessageFooterFactoring = doc.splitTextToSize(
      messageFooterFactoring,
      198,
    );
    doc.text(splitMessageFooterFactoring, 6, finalYTableThree + 32);

    doc.setFontSize(9);

    // DATOS FOOTER (TEXTO)
    doc.line(10, maxPageHeight - 50, 45, maxPageHeight - 50);
    doc.text("Adquisiciones", 20, maxPageHeight - 40);
    doc.setFontSize(7);
    doc.text(
      ordenesApprovalStates[0].nombres +
        " " +
        ordenesApprovalStates[0].apellidos,
      10,
      maxPageHeight - 35,
    );
    doc.setFontSize(9);
    doc.text(
      "Fecha orden: " +
        FORMAT_DATETIME_DDMMYYYY(ordenesApprovalStates[0].fechaCreacion),
      10,
      maxPageHeight - 30,
    );

    let indexGte = null;
    let indexSubGte = 0;

    if (data.ocest_id > 8 && ordenesApprovalStates.length > 3) {
      indexGte = ordenesApprovalStates.length - 1;
      indexSubGte = ordenesApprovalStates.length - 2;
    } else {
      indexSubGte = ordenesApprovalStates.length - 1;
    }

    // APROBADOR TEXT
    if (
      ordenesApprovalStates[1] !== undefined &&
      ((ordenesApprovalStates.length < 4 && indexGte == null) ||
        (ordenesApprovalStates.length < 5 && indexGte != null))
    ) {
      doc.line(60, maxPageHeight - 50, 95, maxPageHeight - 50);
      doc.text("Aprobador", 70, maxPageHeight - 40);
      doc.setFontSize(7);
      doc.text(
        ordenesApprovalStates[1].nombres +
          " " +
          ordenesApprovalStates[1].apellidos,
        60,
        maxPageHeight - 35,
      );
      doc.setFontSize(9);
      doc.text(
        "Fecha aprobación: " +
          FORMAT_DATETIME_DDMMYYYY(ordenesApprovalStates[1].fechaCreacion),
        60,
        maxPageHeight - 30,
      );
      doc.setFontSize(5);
      doc.text(
        "Código Validador: " +
          solicitudesSignApprovalHistory[0].ufdh_id_algoritmo,
        60,
        maxPageHeight - 25,
      );
      doc.setFontSize(9);
    }

    // CONFIRMADOR / GERENTE TEXT
    if (data.ocest_id > 6) {
      if (ordenesApprovalStates[indexSubGte] !== undefined) {
        doc.line(110, maxPageHeight - 50, 145, maxPageHeight - 50);
        doc.text("Sub Gerencia", 120, maxPageHeight - 40);
        doc.setFontSize(7);
        doc.text(
          ordenesApprovalStates[indexSubGte].nombres +
            " " +
            ordenesApprovalStates[indexSubGte].apellidos || "",
          110,
          maxPageHeight - 35,
        );
        doc.setFontSize(9);
        doc.text(
          "Fecha confirmación: " +
            FORMAT_DATETIME_DDMMYYYY(
              ordenesApprovalStates[indexSubGte].fechaCreacion,
            ),
          110,
          maxPageHeight - 30,
        );
        doc.setFontSize(5);
        doc.text(
          "Código Validador: " +
            solicitudesSignApprovalHistory[indexSubGte - 1].ufdh_id_algoritmo,
          110,
          maxPageHeight - 25,
        );
        doc.setFontSize(9);
      }

      if (indexGte != null) {
        if (ordenesApprovalStates[indexGte].estado == 10) {
          if (ordenesApprovalStates[indexGte] !== undefined) {
            // 1. Force the ID to be a string
            const idAprobador = String(
              ordenesApprovalStates[indexGte].idUsuario,
            );
            // 2. Force the array items to be strings, then check for the ID
            const esGerenteGeneral =
              USUARIO_CONFIRMA_GTE_GENERAL.map(String).includes(idAprobador);
            // 3. The Ternary: If true -> "Gerencia General", If false -> "Subrogante"
            const textoFirmaGte = esGerenteGeneral
              ? "Gerencia General"
              : "Subrogante Gerencia";
            doc.line(160, maxPageHeight - 50, 195, maxPageHeight - 50);
            doc.text(textoFirmaGte, 165, maxPageHeight - 40);
            doc.setFontSize(7);
            doc.text(
              ordenesApprovalStates[indexGte].nombres +
                " " +
                ordenesApprovalStates[indexGte].apellidos || "",
              160,
              maxPageHeight - 35,
            );
            doc.setFontSize(9);
            doc.text(
              "Fecha confirmación: " +
                FORMAT_DATETIME_DDMMYYYY(
                  ordenesApprovalStates[indexGte].fechaCreacion,
                ),
              160,
              maxPageHeight - 30,
            );
            doc.setFontSize(5);
            doc.text(
              "Código Validador: " +
                solicitudesSignApprovalHistory[indexGte - 1].ufdh_id_algoritmo,
              160,
              maxPageHeight - 25,
            );
            doc.setFontSize(9);
          }
        }
      }
    }

    // 4. WAIT FOR WATERMARK & SIGNATURES (Crucial Step)
    const finalBlob = await addWaterMark(
      doc,
      ordenesApprovalStates,
      data.oc_id,
      maxPageHeight,
      data,
      indexSubGte,
      indexGte,
    );

    return finalBlob;
  } catch (error) {
    console.error("Error generating Orden PDF:", error);
    throw error;
  }
}

// --- HELPER: Watermark & Signatures ---
async function addWaterMark(
  doc: any,
  ordenesApprovalStates: any,
  nroOrden: number,
  maxPageHeight: number,
  data: any,
  indexSubGte: any,
  indexGte: any,
): Promise<Blob> {
  try {
    const totalPages = doc.internal.getNumberOfPages();
    const width = doc.internal.pageSize.getWidth();
    const height = doc.internal.pageSize.getHeight();

    // 1. Load Watermark Image
    const waterMarkImg = await loadImage(SelloAguaOrden);

    // Apply Watermark to all pages
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      // doc.setGState(new doc.GState({ opacity: 0.2 })); // Uncomment if supported
      doc.addImage(
        waterMarkImg,
        "PNG",
        0,
        20,
        width,
        height,
        undefined,
        "FAST",
      );
    }

    // 2. Load Signature Images in Parallel
    const signaturePromises: Promise<HTMLImageElement | null>[] = [];

    // Solicitante
    const srcSolicita =
      "data:image/png;base64," +
      decodeBase64Image(ordenesApprovalStates[0].firma);
    signaturePromises.push(loadImage(srcSolicita));

    // Aprobador
    let srcAprobador = null;
    if (ordenesApprovalStates[1] !== undefined) {
      srcAprobador =
        "data:image/png;base64," +
        decodeBase64Image(ordenesApprovalStates[1].firma);
      signaturePromises.push(loadImage(srcAprobador));
    } else {
      signaturePromises.push(Promise.resolve(null));
    }

    // Confirmador
    let srcConfirmador = null;
    if (data.ocest_id > 6 && ordenesApprovalStates[indexSubGte] !== undefined) {
      srcConfirmador =
        "data:image/png;base64," +
        decodeBase64Image(ordenesApprovalStates[indexSubGte].firma);
      signaturePromises.push(loadImage(srcConfirmador));
    } else {
      signaturePromises.push(Promise.resolve(null));
    }

    // Gerente
    let srcGerente = null;
    if (data.ocest_id > 6 && ordenesApprovalStates[indexGte] !== undefined) {
      srcGerente =
        "data:image/png;base64," +
        decodeBase64Image(ordenesApprovalStates[indexGte].firma);
      signaturePromises.push(loadImage(srcGerente));
    } else {
      signaturePromises.push(Promise.resolve(null));
    }

    // Wait for all
    const [imgSolicita, imgAprobador, imgConfirmador, imgGerente] =
      await Promise.all(signaturePromises);

    // 3. Draw Signatures on the LAST page
    doc.setPage(totalPages);
    doc.setFont(undefined, "bold");

    if (imgSolicita) {
      doc.addImage(imgSolicita, "PNG", 10, maxPageHeight - 70, 50, 40);
    }

    if (imgAprobador) {
      doc.addImage(imgAprobador, "PNG", 55, maxPageHeight - 70, 50, 40);
    }

    if (imgConfirmador) {
      doc.addImage(imgConfirmador, "PNG", 100, maxPageHeight - 70, 50, 40);
    }

    if (imgGerente) {
      doc.addImage(imgGerente, "PNG", 145, maxPageHeight - 70, 50, 40);
    }

    doc.setTextColor(50);

    // 4. Return Blob
    return doc.output("blob");
  } catch (error) {
    console.error("Error drawing signatures/watermark:", error);
    throw error;
  }
}

export default CreatePdfTableOrdenesBlob;
